import NodeRSA from "node-rsa";
import * as constant from "../constant";

/**
 * Encrypts the given data using the provided public key.
 *
 * @param {string} data - The data to be encrypted.
 * @param {string} publicKey - The public key used for encryption.
 * @returns {string} The encrypted data in base64 format.
 */
export function encryptDataWithPublicKey(data) {
    const publicKey = constant.ENCRYPTION_PUBLIC_KEY.replace(/\\n/g, '\n');
    console.log(publicKey)
    const key = new NodeRSA(publicKey, "pkcs8-public");
    const encryptedData = key.encrypt(data, 'base64');
    return encryptedData;
}